import { type PageProps } from 'gatsby'
import React, { useEffect, useState } from 'react'

import Link from '@/components/link/link'
import { useSiteMetadata } from '@/components/root-element'

import * as styles from './share-buttons.module.scss'

type Props = {
  location?: PageProps['location']
  visibleaAt?: number
}
const ShareButtons: React.FC<Props> = ({ location, visibleaAt = 40 }) => {
  const { siteUrl } = useSiteMetadata()
  const shareUrl = siteUrl + location?.pathname
  const [isFixed, setIsFixed] = useState('')

  useEffect(() => {
    const isSticky = (): void => {
      const scrollTop = window.scrollY
      if (scrollTop >= visibleaAt) {
        setIsFixed(styles.show)
      } else {
        setIsFixed('')
      }
    }

    window.addEventListener('scroll', isSticky)

    return () => {
      window.removeEventListener('scroll', isSticky)
    }
  }, [visibleaAt])

  return (
    <div className={`${styles.shareButtonsFixed} ${isFixed}`}>
      <div className={styles.linkedin}>
        <Link
          to={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
        >
          <span>Share on Linkedin</span>
        </Link>
      </div>
      <div className={styles.twitter}>
        <Link to={`http://twitter.com/share?url=${shareUrl}`}>
          <span>Share on X</span>
        </Link>
      </div>
      <div className={styles.email}>
        <Link
          to={`mailto:?subject=I wanted you to see this site&amp;body=Check out this site ${shareUrl}"`}
        >
          <span>Share by E-mail</span>
        </Link>
      </div>
    </div>
  )
}

export default ShareButtons
